import { SortType } from '@hooks'
import { getCommandRequestData, getSortParamRequest } from '@helpers'
import { CommandParameterDTO, TimeLineDTOType } from '@types'

import { getExpandsParamForObjectY } from './getExpandsParamForObjectY'
import { getFilterParamForObjectY } from './getFilterParamForObjectY'

export const getObjectYCommandParams = ({
  commandParameters,
  config,
  saRSQLFilter,
  objectYKeyFieldsValues,
  sort,
}: {
  commandParameters?: CommandParameterDTO[]
  config: TimeLineDTOType
  objectYKeyFieldsValues?: unknown[]
  saRSQLFilter: string | null
  sort: SortType[]
}) => {
  const objectYParams = commandParameters ? getCommandRequestData(commandParameters, {}) : {}
  const paramsExpands =
    typeof objectYParams['expands'] === 'string' && objectYParams['expands']?.length
      ? objectYParams['expands']?.split(',')
      : []
  const paramsSort =
    typeof objectYParams['sort'] === 'string' && objectYParams['sort']?.length
      ? objectYParams['sort']?.split(';')
      : []

  const configFilter = getFilterParamForObjectY({
    config,
    objectYKeyFieldsValues,
  })

  const paramsFilter = []

  if (objectYParams?.filter) {
    paramsFilter.push(objectYParams?.filter)
  }

  if (configFilter) {
    paramsFilter.push(configFilter)
  }

  if (saRSQLFilter) {
    paramsFilter.push(saRSQLFilter)
  }

  return {
    ...objectYParams,
    expands: getExpandsParamForObjectY(config).concat(paramsExpands),
    filter: paramsFilter.join(';'),
    sort: paramsSort.concat(getSortParamRequest(sort) || []),
  }
}
